import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class CustomerGroupsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'permissions': [
                    'CURRENT_ACCOUNT_PERMISSION',
                    'PURCHASE_ORDER_PERMISSION',
                    'ORDER_PERMISSION',
                    'USER_PERMISSION',
                    'CREATE_USER_PERMISSION',
                    'SUPPORT_PERMISSION',
                ]
            },
            errors: []
        }
    }

    customersGroups() {
        const customersGroups = this.content()
        return customersGroups.map(customer_group => {
            return {
                name: customer_group.name,
                code: customer_group.code,
                customers: this._customersAdapter(customer_group.customers)
            }})
        }


    _customersAdapter(customers) {
        return customers.map(customer => {
            return {
                code: customer.code,
                fantasyName: customer.fantasy_name,
                businessName: customer.business_name,
                taxpayerIdentificationNumber: customer.taxpayer_identification_number
            };
        });
    }
}